export const CITIES = [
    {
        slug: "toronto",
        name: "Toronto",
        blurb: "From downtown condos to Etobicoke driveways, our dispatch covers every Toronto neighbourhood, seven days a week.",
    },
    {
        slug: "scarborough",
        name: "Scarborough",
        blurb: "From Agincourt to the Bluffs, our flatbeds run Scarborough daily — quick pickups off Kennedy, Markham Rd and the 401.",
    },
    {
        slug: "north-york",
        name: "North York",
        blurb: "Willowdale, Downsview, Don Mills — we tow from every North York street, plaza and underground garage.",
    },
    {
        slug: "etobicoke",
        name: "Etobicoke",
        blurb: "Rexdale to Long Branch, our Etobicoke pickups are fast — often same-day along the QEW and 427 corridors.",
    },
    {
        slug: "mississauga",
        name: "Mississauga",
        blurb: "Port Credit to Malton, we buy cars across Mississauga with free towing straight from your driveway or work lot.",
    },
    {
        slug: "brampton",
        name: "Brampton",
        blurb: "Bramalea, Heart Lake, Mount Pleasant — our Brampton drivers pay cash and tow free anywhere in the city.",
    },
    {
        slug: "vaughan",
        name: "Vaughan",
        blurb: "Woodbridge, Maple, Thornhill and Kleinburg — one call and a flatbed is on its way to your Vaughan address.",
    },
    {
        slug: "markham",
        name: "Markham",
        blurb: "Unionville to Milliken, we handle Markham pickups daily with paperwork done for you on the spot.",
    },
    {
        slug: "richmond-hill",
        name: "Richmond Hill",
        blurb: "From Bayview Hill to Jefferson, our Richmond Hill service is quick, courteous and always cash-in-hand.",
    },
    {
        slug: "pickering",
        name: "Pickering",
        blurb: "Liverpool, Brock Ridge, Seaton — we cover all of Pickering with free flatbed towing, 7 days a week.",
    },
    {
        slug: "ajax",
        name: "Ajax",
        blurb: "Anywhere in Ajax — from the waterfront to north of the 401 — we arrive on time and pay cash on the spot.",
    },
    {
        slug: "whitby",
        name: "Whitby",
        blurb: "Brooklin to Port Whitby, our drivers make selling your scrap car in Whitby a one-call job.",
    },
    {
        slug: "oakville",
        name: "Oakville",
        blurb: "Bronte, Glen Abbey, Kerr Village — we tow free across Oakville and pay competitive cash for any vehicle.",
    },
    {
        slug: "newmarket",
        name: "Newmarket",
        blurb: "From Main Street to Stonehaven, Newmarket sellers get the same top-cash offer and free pickup as downtown.",
    },
];

export const findCity = (slug) => CITIES.find((c) => c.slug === slug);
